import * as React from "react";

import { cn } from "@/lib/utils";

import "./loader.scss";

interface Props {
  className?: string;
  inline?: boolean;
}

export const Loader: React.FC<Props> = ({ className, inline }) => {
  const animation = (
    <div className={cn("loader-pulse", className)}>
      <svg className="loader-pulse__arrow" viewBox="0 0 16 16" fill="none">
        <path d="M8 0L0 15.3L8 11.7L16 15.3Z" fill="currentColor" />
      </svg>
      <div className="loader-pulse__ring" />
    </div>
  );

  if (inline || className) return animation;

  return <div className="loader-container">{animation}</div>;
};
